import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { TabsProps } from './Tabs.types';
import { cn } from '../../utils';

import './Tabs.scss';

const tabTriggerClasses = [
  'sui-px-3',
  'sui-py-2',
  'sui-label',
  'sui-font-sans',
  'sui-cursor-pointer',
  'sui-border-0',
  'sui-bg-transparent',
  'sui-text-neutral-text',
  'sui-border-b-transparent',
  'hover:sui-text-action-text-hover',
  'hover:sui-border-b-action-border-hover',
];

const Tabs: React.FC<TabsProps> = ({
  tabs,
  onChange,
  defaultValue,
  ariaLabel,
  value,
  ...props
}) => {
  return (
    <TabsPrimitive.Root
      data-testid='tabs-component'
      defaultValue={defaultValue}
      onValueChange={onChange}
      value={value}
      {...props}
    >
      <TabsPrimitive.List data-testid='tabs-component__tab-list' aria-label={ariaLabel}>
        {tabs.map((item) => {
          return (
            <TabsPrimitive.Trigger
              data-testid={`tabs-component__tab-trigger-${item.value}`}
              className={cn(tabTriggerClasses)}
              value={`${item.value}`}
              key={`${item.value}-trigger`}
            >
              {item.label}
            </TabsPrimitive.Trigger>
          );
        })}
      </TabsPrimitive.List>
      {tabs.map((item) => (
        <TabsPrimitive.Content
          data-testid={`tabs-component__tab-content-${item.value}`}
          value={`${item.value}`}
          key={`${item.value}-content`}
        >
          {item.content}
        </TabsPrimitive.Content>
      ))}
    </TabsPrimitive.Root>
  );
};

export default Tabs;
